export default "__VITE_ASSET__DT8Ifh2q__"